module.exports = __webpack_public_path__ + "igLoadingSmall.846807455b2c83ff5812.gif";


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/assets/img/igLoadingSmall.gif
// module id = ../../../../../client/assets/img/igLoadingSmall.gif
// module chunks = styles